import { ChartResource } from '../charts/chart-response.types';
import { ChartDomain } from '@mode/shared/contract-common';

export function toChart(resource: ChartResource): ChartDomain.Chart {
  return {
    token: resource.token,
    colorPaletteToken: resource.color_palette_token,
    switchViewToken: resource.switch_view_token,
    version: resource.view_version,
    encoding: resource.view_vegas.encoding,
    chartType: resource.view_vegas.chartType,
    description: resource.view_vegas.description,
    fieldFormats: resource.view_vegas.fieldFormats,
    fieldColors: resource.view_vegas.fieldColors,
    facetSizes: resource.view_vegas.facetSizes,
    format: resource.view_vegas.format,
    title: resource.view_vegas.title,
    caption: resource.view_vegas.caption,
    createdAt: resource['created_at'],
    isAutoUpdateDisabled: resource.view_vegas.isAutoUpdateDisabled ?? false,
  };
}
